import { CommonDialogs } from "@mcleod/common";
import { BlurEvent, Textbox, Label, ForcedCase, Snackbar, ScreenStack } from "@mcleod/components";
import { Api, Navigation } from "@mcleod/core";
import { DuplicateId } from "@mcleod/dispatch";

const viewTableURL = "/lme/powerbroker/DistanceRateTable?mode=update&key=";

export class CopyDistanceRateTable {

    static async copyPromptBlur(event: BlurEvent) {
        const tb = event.target as Textbox;
        if (tb.text) {
            const response = await DuplicateId.checkManualCode("rate_header", tb.text);
            if (response.data[0]?.is_duplicate) {
                const warning = DuplicateId.getDuplicateCodeValidationWarning(tb.text);
                tb.showAdhocTooltip(warning, { timeout: 5000 });
                tb.clear();
            } else {
                tb.validationWarning = null;
                tb.tooltip = null;
            }
        }
    }

    static async enforceLength(tb: Textbox) {
        if (tb.text.length > 7) {
            const warning = "You have exceeded the 7 character limit.";
            tb.showAdhocTooltip(warning, { timeout: 5000 });
            tb.text = tb.text.substring(0, 7);
        }
    }

    static async showModal(sourceId: string): Promise<void> {
        const newId = await CommonDialogs.showInputDialog(
            new Label({ fontBold: true, text: "Enter a name for the new Distance Rate Table" }),
            `Copy of ${sourceId}`,
            {
                required: true,
                forcedCase: ForcedCase.UPPER,
                onBlur: async (event: BlurEvent) => this.copyPromptBlur(event),
                onKeyUp: async (event) => this.enforceLength(event.target as Textbox)
            },
            { panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" } }
        );

        if (newId) {
            const progressSnackbar = Snackbar.showDownloadSnackbar(
                "Action in progress...",
                "Copying Distance Rate Table",
                { persist: true, targetPanel: ScreenStack.getSnackbarTarget() }
            );
            try {
                await Api.post("lme/powerbroker/rate-header/copy", {
                    "source_id": sourceId,
                    "new_id": newId
                });
                Navigation.navigateTo(viewTableURL + newId, { newTab: true });
            } finally {
                progressSnackbar.dismiss();
            }
        }
    }

}
